// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-css {
	display: block;
	font-size: 16px;
	font-family: sans-serif;
	font-weight: 700;
	color: #444;
	line-height: 1.3;
	padding: .6em 1.4em .5em .8em;
	width: 100%;
	max-width: 100%;
	box-sizing: border-box;
	margin: 0;
	border: 1px solid #aaa;
	box-shadow: 0 1px 0 1px rgba(0,0,0,.04);
	border-radius: .5em;
	appearance: none;
	background-color: #fff;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}),
	  linear-gradient(to bottom, #ffffff 0%,#e5e5e5 100%);
	background-repeat: no-repeat, repeat;
	background-position: right .7em top 50%, 0 0;
	background-size: .65em auto, 100%;
}
.select-css::-ms-expand {
	display: none;
}
.select-css:hover {
	border-color: #888;
}
.select-css:focus {
	border-color: #aaa;
	box-shadow: 0 0 1px 3px rgba(59, 153, 252, .7);
	box-shadow: 0 0 0 3px -moz-mac-focusring;
	color: #222;
	outline: none;
}
.select-css option {
	font-weight:normal;
}
/* .tempChart{
	height: 400px !important;
} */
`, "",{"version":3,"sources":["webpack://./src/pages/Humidity/index.css"],"names":[],"mappings":"AAAA;CACC,cAAc;CACd,eAAe;CACf,uBAAuB;CACvB,gBAAgB;CAChB,WAAW;CACX,gBAAgB;CAChB,6BAA6B;CAC7B,WAAW;CACX,eAAe;CACf,sBAAsB;CACtB,SAAS;CACT,sBAAsB;CACtB,uCAAuC;CACvC,mBAAmB;CAGnB,gBAAgB;CAChB,sBAAsB;CACtB;sDACqD;CACrD,oCAAoC;CACpC,4CAA4C;CAC5C,iCAAiC;AAClC;AACA;CACC,aAAa;AACd;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,8CAA8C;CAC9C,wCAAwC;CACxC,WAAW;CACX,aAAa;AACd;AACA;CACC,kBAAkB;AACnB;AACA;;GAEG","sourcesContent":[".select-css {\n\tdisplay: block;\n\tfont-size: 16px;\n\tfont-family: sans-serif;\n\tfont-weight: 700;\n\tcolor: #444;\n\tline-height: 1.3;\n\tpadding: .6em 1.4em .5em .8em;\n\twidth: 100%;\n\tmax-width: 100%;\n\tbox-sizing: border-box;\n\tmargin: 0;\n\tborder: 1px solid #aaa;\n\tbox-shadow: 0 1px 0 1px rgba(0,0,0,.04);\n\tborder-radius: .5em;\n\t-moz-appearance: none;\n\t-webkit-appearance: none;\n\tappearance: none;\n\tbackground-color: #fff;\n\tbackground-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E'),\n\t  linear-gradient(to bottom, #ffffff 0%,#e5e5e5 100%);\n\tbackground-repeat: no-repeat, repeat;\n\tbackground-position: right .7em top 50%, 0 0;\n\tbackground-size: .65em auto, 100%;\n}\n.select-css::-ms-expand {\n\tdisplay: none;\n}\n.select-css:hover {\n\tborder-color: #888;\n}\n.select-css:focus {\n\tborder-color: #aaa;\n\tbox-shadow: 0 0 1px 3px rgba(59, 153, 252, .7);\n\tbox-shadow: 0 0 0 3px -moz-mac-focusring;\n\tcolor: #222;\n\toutline: none;\n}\n.select-css option {\n\tfont-weight:normal;\n}\n/* .tempChart{\n\theight: 400px !important;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
